import React from "react";
import T from "prop-types";
import { translateProps } from "MODULES/shared/decorators";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { StatusTag } from "MODULES/shared/components";

export function RMA({ rma, wcAndCreditRequested }) {
  return (
    rma && (
      <StatusTag
        title={`RMA Requested ${wcAndCreditRequested ? "for WC & Credit" : ""}`}
        icon="cog"
      />
    )
  );
}

RMA.propTypes = {
  rma: T.bool.isRequired,
  wcAndCreditRequested: T.bool.isRequired
};

const withProps = translateProps(({ lineItems }) => ({
  rma: lineItems.some(lineItem =>
    lineItem.customer_rmas.some(rma => !rma.cancelled)
  ),
  wcAndCreditRequested: lineItems
    .filter(lineItem => !lineItem.cancelled)
    .some(lineItem =>
      lineItem.customer_rmas.some(
        rma =>
          rma.warranty_consideration && rma.credit_requested && !rma.cancelled
      )
    ),
  cancelledRma: lineItems
    .filter(lineItem => !lineItem.cancelled)
    .some(
      lineItem =>
        lineItem.customer_rmas.length > 0 &&
        lineItem.customer_rmas.every(rma => rma.cancelled)
    ),
  resolvedRma: lineItems.some(lineItem =>
    lineItem.customer_rmas.some(
      rma => !rma.cancelled && rma.shipped && rma.outgoing_awb_number
    )
  )
}));

export const CustomerRmaWarning = withSalesOrder(withProps(RMA));

export function CancelledRma({ cancelledRma }) {
  return (
    cancelledRma && <StatusTag title="Cancelled Customer RMA" icon="ban" />
  );
}

export const CancelledCustomerRmaWarning = withSalesOrder(
  withProps(CancelledRma)
);

export function ResolvedRmaTag({ resolvedRma }) {
  return (
    resolvedRma && (
      <StatusTag title="Resolved RMA" icon="check-circle" display="success" />
    )
  );
}

export const ResolvedRmaWarning = withSalesOrder(withProps(ResolvedRmaTag));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Warnings/RMA.jsx